import * as Yup from 'yup';

export const IndicateEmploymentStatusSchema = Yup.object().shape({
  employmentType: Yup.string().required('Employment type is required'),
});

export interface IndicateEmploymentStatusDataType {
  employmentType: string;
}

export const IndicateEmploymentStatusInitialValues: IndicateEmploymentStatusDataType =
  {
    employmentType: 'Exclusive',
  };

export interface IndicateEmploymentStatusInterface {
  employmentType: string;
}
